import { DIRECTORY_PAGE_LIMIT_DEFAULT } from "@thalamos/haven-common";

import { apiHooks } from "../../api/index.js";
import { createRoute } from "../../routing/createRoute.js";
import { useDirectoryQuery } from "../Admin/useDirectoryQuery.js";
import { UsersListContent } from "../Admin/UsersListContent.js";

/**
 * The accounts an organisation's admin manages, filtered by name or email
 * address. Which accounts those are is the server's to decide.
 *
 * It offers no way to create an account: that stays with Thalamos, because a
 * mistyped address can be neither corrected nor deleted.
 */
export const OrganisationUsersPage = () => {
  const { query, input, offset, setQuery, setOffset } = useDirectoryQuery();

  const [{ data, loading, error }] = apiHooks.user.directory({
    query,
    offset,
    limit: DIRECTORY_PAGE_LIMIT_DEFAULT,
  });

  return (
    <UsersListContent
      page={data}
      loading={loading}
      failed={error !== undefined && error !== null}
      filter={input}
      onFilter={setQuery}
      offset={offset}
      onPageChange={setOffset}
      accountPath={createRoute.user}
    />
  );
};
